export default __webpack_public_path__ + "static/media/zombie_walk.cc399b07.gif";